/****************************************************
 * Module Name:  holdStoneMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import { DataGridPro, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { Box, Button, Stack, Tab, Tabs, Tooltip, Typography, MenuItem, Menu } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import Utility from "../../utility/utility";
import { useEffect } from "react";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import StoneDetailModal from "../common/stoneDetailModal";
import Constants from "../../utility/constants";
import ReleaseStoneModal from "./releaseStoneModal";
import StoneProxy from "../../utility/proxy/manager/stoneProxy";
import { RiInboxUnarchiveLine } from "react-icons/ri";
import SellMemoModal from "./sellMemoModal";
import { DiamondOutlined, SearchOutlined } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import CommonStoneSelection from "../common/commonStoneSelection";
import HoldProxy from "../../utility/proxy/manager/holdProxy";
import Select from "react-select";
import WatchlistProxy from "../../utility/proxy/manager/watchlistProxy";
import OfferModal from "./OfferModal";
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import VisibilityOutlined from "@mui/icons-material/VisibilityOutlined";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import CreateMemoModal from "./createMemoModal";
import CommonSnackbar from "../common/commonSnackBar";
import VideoLibraryTwoToneIcon from '@mui/icons-material/VideoLibraryTwoTone';
import StoneMediaModal from "../common/stoneMediaModal";
import PacketHistoryModal from "../common/packetHistoryModal";
import KapanHistoryModal from "../manufacturing/operations/kapanHistoryModal";
import PageTitle from "../common/pageTitle";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";
import WatchlistModal from "../watchlist/watchlistModal";
import Download from "@mui/icons-material/Download";
import { createExcelFile } from "../common/createExcelFile";
import { TbTableExport } from "react-icons/tb";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { styled, alpha } from "@mui/material/styles";

const StyledMenuButtons = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 100,
    color:
      theme.palette.mode === 'light'
        ? 'rgb(55, 65, 81)'
        : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      fontSize: 15,
      padding: "4px 12px",
      '& .MuiSvgIcon-root': {
        fontSize: 16,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));


const HoldStoneMaster = () => {
  const [listData, setListData] = useState([]);
  const [selectionModel, setSelectionModel] = useState([]);
  const [show, setShow] = useState(false);
  const [stoneId, setStoneId] = useState("");
  const [showStoneDetailModal, setShowStoneDetailModal] = useState(false);
  const [errorSnackbar, setErrorSnackbar] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [listLoader, setListLoader] = useState(false);
  const [showSellModal, setShowSellModal] = useState(false);
  const [loadingProformaButton, setLoadingProformaButton] = useState(false);
  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("");
  const [customerData, setCustomerData] = useState({
    customer: "",
    customerOptions: [],
  });
  const [fetchData, setFetchData] = useState(false);
  const [columnNames, setColumnNames] = React.useState([]);
  const [isPermitted, setIsPermitted] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [showOfferModal, setShowOfferModal] = useState(false);
  const [showReleaseModal, setShowReleaseModal] = useState(false);
  const [releaseData, setReleaseData] = useState([]);
  const [customerId, setCustomerId] = useState({});
  const [warningStatus, setWarningStatus] = useState([]);

  const [noOfSelectedStones, setNoOfSelectedStones] = useState("0");
  const [selectedTotalSize, setSelectedTotalSize] = useState("0");
  const [selectedAvgDiscount, setSelectedAvgDiscount] = useState("0");
  const [selectedavgPrice, setSelectedavgPrice] = useState("0");
  const [selectedtotalPrice, setSelectedtotalPrice] = useState("0");

  const [disableAllButtons, setDisableAllButtons] = useState(false);
  const [watchlistLoader, setWatchlistLoader] = useState(false);

  const [tabValue, setTabValue] = useState(0);
  const [activeTab, setActiveTab] = useState("");
  const [showNaturalTab, setShowNaturalTab] = useState(false);
  const [showLabGrownTab, setShowLabGrownTab] = useState(false);

  const [stoneMediaURL, setStoneMediaURL] = useState([]);
  const [showStoneMediaModal, setShowStoneMediaModal] = useState(false);
  const [showPacketDetailModal, setShowPacketDetailModal] = useState(false);
  const [showKapanDetailModal, setShowKapanDetailModal] = useState(false);
  const [packetId, setPacketId] = useState("");
  const [kapanId, setKapanId] = useState("");

  const [showUserDetailModal, setShowUserDetailModal] = useState(false);

  const [showWatchlistModal, setShowWatchlistModal] = useState(false);
  const [watchlistData, setWatchlistData] = useState([]);

  // eslint-disable-next-line
  const [local_Permission, setLocal_Permission] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) =>
        iPermission.permissionid === Constants.PERMISSIONS.OPERATION_STONEHOLD_HOLD
    )
  );
  // eslint-disable-next-line
  const [sellPermission, setSellPermission] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) =>
        iPermission.permissionid === Constants.PERMISSIONS.DIRECTSALE
    )
  );

  const [offerPermission] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) =>
        iPermission.permissionid === Constants.PERMISSIONS.DIRECTOFFER
    )
  );

  // eslint-disable-next-line
  const [naturalPermission, setNaturalPermission] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) => iPermission.permissionid === Constants.PERMISSIONS.STONETYPE_NATURAL
    )
  );

  // eslint-disable-next-line
  const [labGrownPermission, setLabGrownPermission] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) => iPermission.permissionid === Constants.PERMISSIONS.STONETYPE_LABGROWN
    )
  );

  // eslint-disable-next-line
  const [fullExcelPermission, setFullExcelPermission] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) =>
        iPermission.permissionid === Constants.PERMISSIONS.DIRECT_EXCEL_DOWNLOAD_FULL
    )
  );

  useEffect(() => {
    if (listLoader || watchlistLoader) {
      setDisableAllButtons(true);
    } else {
      setDisableAllButtons(false);
    }
  }, [listLoader, watchlistLoader]);

  useEffect(() => {
    PageTitle("OPERATION_HOLD");
    let showNaturalTab = Utility.isReadAllowed(naturalPermission);
    let showLabGrownTab = Utility.isReadAllowed(labGrownPermission);
    let activeTab = showNaturalTab ? "Natural" : showLabGrownTab ? "Lab Grown" : "Natural";
    setShowNaturalTab(showNaturalTab);
    setShowLabGrownTab(showLabGrownTab);
    setActiveTab(activeTab);
  }, []);

  useEffect(() => {
    // Ensure checkPermission is called after all the state updates
    if (activeTab) {
      setListData([]);
      loadTotalData([]);
      checkPermission();
    }
  }, [activeTab]);

  const checkPermission = () => {
    if (local_Permission.length > 0) {
      setIsPermitted(true)
    }
    getAllCustomerData();
  }

  const getAllCustomerData = () => {
    if (Constants.loggedInUser.usertype !== "C") {
      HoldProxy.GetCustomersCreatedHold(
        local_Permission.length > 0 ? -1 : Constants.loggedInUser.id,
        Constants.loggedInUser.usertype,
        activeTab === "Natural",
        (response) => {
          prepareUserData(response);
        });
    } else {
      prepareUserData([{
        "id": Constants.loggedInUser.id,
        "companyname": Constants.loggedInUser.companyname,
      }])
    }
  };

  const prepareUserData = (response) => {

    let optionsArray = [];
    optionsArray.push({ value: "*", label: "-- ANY --" });
    response.map((data) => {
      let option = {
        value: data.id,
        label: data.companyname,
      };
      optionsArray.push(option);
      return true;
    });

    setCustomerData({
      customerOptions: optionsArray,
      customer: optionsArray.length > 0 ? [optionsArray[0]] : []
    });
    setFetchData(true);

    return true;
  };

  const fullOptionToValue = (selectedData, mainData) => {
    let newArr = [];
    selectedData.map((data) => {
      if (data.value === "*") {
        return (mainData.map((option) => {
          if (option.value !== "*") {
            newArr.push(option.value);
            return true;
          }
          return true;
        })).join(",");
      }
      return true;
    })
    return Utility.GetValueArrayWithStarReplace(selectedData, newArr).join(",");
  };

  const handleSelection = (data) => {
    const [tempStockData, tempSelectionModel] = Utility.handleSelection(data, listData, selectionModel);

    setListData(tempStockData);
    setSelectionModel(tempSelectionModel);
  }

  useEffect(() => {
    if (fetchData) {
      if (customerData.customer && customerData.customerOptions.length > 1) {
        handleSearch();
      }
    }
  }, [fetchData, customerData.customer]);

  const handleClose = () => {
    setShowStoneDetailModal(false);
    setShowPacketDetailModal(false);
    setShowStoneMediaModal(false);
    setShowReleaseModal(false);
    setShowSuccessSnackbar(false);
  };

  const handleValidation = (customer) => {
    //TODO do validation if needed here
    return true;
  };

  const handleSearch = () => {
    setListLoader(true);
    let selectedCustomers = Constants.loggedInUser.usertype === "C" ? " " : fullOptionToValue(customerData.customer, customerData.customerOptions);

    StoneProxy.GetAllHoldStone(
      Constants.loggedInUser.usertype,
      isPermitted ? -1 : Constants.loggedInUser.id,
      selectedCustomers === "" ? " " : selectedCustomers,
      activeTab === "Natural",
      (responseData) => {
        if (responseData) {
          const distinctStatus = Utility.getDistinctOptions(responseData, 'status');
          const distinctUsername = Utility.getDistinctOptions(responseData, 'username');
          const distinctCustomerCompanyName = Utility.getDistinctOptions(responseData, 'customercompanyname');

          const preparedColumns = Utility.PrepareColumns(columnsData);

          const index = preparedColumns.findIndex(col => col.field === "customercompanyname");

          if (index !== -1) {
            const newColumns = [
              {
                field: "username",
                headerName: "HELD BY",
                headerAlign: "center",
                align: "center",
                width: 115,
                valueFormatter: (params) => params.value,
                renderCell: (params) => params.value,
                type: 'singleSelect',
                valueOptions: distinctUsername,
                filterOperators: Utility.combinedFilters(),
              },
              {
                field: "holdcreatedat",
                headerName: "HELD AT",
                headerAlign: "center",
                align: "center",
                width: 170,
                type: "dateTime",
                valueGetter: (params) => {
                  return params.value ? new Date(params.value) : null;
                },
                renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
              }
            ];

            preparedColumns.splice(index + 1, 0, ...newColumns);
          }

          // Find and update the status column with distinct statuses
          if (preparedColumns) {
            const updatedColumns = preparedColumns.map(col => {
              if (col.field === 'status') {
                return {
                  ...col,
                  type: 'singleSelect',
                  valueOptions: distinctStatus,
                  filterOperators: Utility.combinedFilters(),
                };
              } else if (col.field === 'customercompanyname') {
                return {
                  ...col,
                  type: 'singleSelect',
                  valueOptions: distinctCustomerCompanyName,
                  filterOperators: Utility.combinedFilters(),
                };
              }
              return col;
            });
            setColumnNames(updatedColumns);
          }

          setListData(responseData);
          setListLoader(false);
          setFetchData(false);
          if (selectionModel.length <= 0)
            loadTotalData(responseData);
        } else {
          setErrorSnackbar(true)
          setErrorMessage(Constants.APiFailErrorMessage)
          setListLoader(false);
          setFetchData(false);
        }
      });
  };

  const handlePacketDetailModal = (params, kapanid) => {
    setPacketId(params);
    setKapanId(kapanid);
    setShowPacketDetailModal(true);
  };

  const releaseStone = (data) => {
    setLoadingButton(true);
    StoneProxy.ReleaseStones(data, (responseData) => {
      if (responseData && responseData.status === "Success") {
        handleSearch();
        setShow(false);
        setLoadingButton(false);
        setShowSuccessSnackbar(true);
        setSuccessMessage("Stone Release Successfully");
        setSnackbarVariant("success");
      } else {
        setErrorSnackbar(true);
        setLoadingButton(false);
        setErrorMessage(responseData ? responseData.errorMessage : Constants.APiFailErrorMessage)
      }
      setShowReleaseModal(false);
    });
  };

  const sellStones = (data) => {
    setLoadingButton(true);
    StoneProxy.SellStones(data, (responseData) => {
      if (responseData && responseData.invoicepdf) {
        handleSearch();
        setShowSuccessSnackbar(true);
        setSuccessMessage("Stones sold successfully");
        setSnackbarVariant("success");
        setShowSellModal(false);
        setLoadingButton(false);
      } else {
        setShowSuccessSnackbar(true);
        setShowSellModal(false);
        setSuccessMessage(responseData ? responseData.error : Constants.APiFailErrorMessage);
        setSnackbarVariant("error");
        setLoadingButton(false);
      }
    });
  };

  const createMemo = (data) => {
    setLoadingButton(true);
    const usertype = Constants.loggedInUser.usertype;
    StoneProxy.CreateMemo(data, usertype, (responseData) => {
      if (responseData && responseData.status === "Success") {
        setShowSuccessSnackbar(true);
        setSuccessMessage("Memo created successfully");
        setSnackbarVariant("success");
        setShow(false);
        setLoadingButton(false);
      } else {
        setShowSuccessSnackbar(true);
        setSuccessMessage(responseData ? responseData.errorMessage : Constants.APiFailErrorMessage);
        setSnackbarVariant("error");
        setLoadingButton(false);
      }
    });
  };

  const addToWatchlist = (data) => {
    setWatchlistLoader(true);
    WatchlistProxy.AddToWatchlist(data, (res) => {
      if (res && res.status === "Success") {
        //Success
        setShowWatchlistModal(false);
        setShowSuccessSnackbar(true);
        setSuccessMessage("Watchlist Added successfully");
        setSnackbarVariant("success");
        setWatchlistLoader(false);
      } else {
        // Failure
        setShowWatchlistModal(false);
        setShowSuccessSnackbar(true);
        setSuccessMessage(res ? res.errorMessage : Constants.APiFailErrorMessage);
        setSnackbarVariant("error");
        setWatchlistLoader(false);
      }
    })
  };

  const getSummaryData = () => {

    let data = [];
    if (selectionModel && selectionModel.length > 0) {
      data = listData.filter((data) => selectionModel.includes(data.stoneid));
    } else {
      data = listData;
    }

    let noOfStones = 0;
    let totalSize = 0;
    let totalAmount = 0;
    let total = 0;

    data.forEach(item => {
      noOfStones += 1;

      if (Utility.isValueValid(item.size)) {
        totalSize += Number(item.size);
      }

      if (Utility.isValueValid(item.total)) {
        totalAmount += Number(item.total);
      }

      if (
        Utility.isValueValid(item.price) &&
        Utility.isValueValid(item.discount) &&
        Utility.isValueValid(item.size)
      ) {
        const effectivePrice = (100 * Number(item.price)) / (100 + Number(item.discount));
        total += Number(item.size) * effectivePrice;
      }
    });

    return {
      ID: noOfStones,
      CTS: (Number(totalSize)).toFixed(2),
      DIS: (Number((100 - (totalAmount / total) * 100) * -1)).toFixed(2),
      PPC: (Number(totalAmount / totalSize)).toFixed(2),
      TOTAL: (Number(totalAmount)).toFixed(2),
    };

  }

  const getExcelData = (fullExcel) => {
    let data = [];

    if (selectionModel && selectionModel.length > 0) {
      data = listData.filter((data) => selectionModel.includes(data.stoneid));
    } else {
      data = listData;
    }

    const excelData = data.map(item => {

      return {
        REPORT: item.certificateid,
        SHAPE: item.shape,
        ID: item.stoneid,
        CTS: item.size,
        COL: item.colortype === "WHITE" ? item.color : item.colordescriptions,
        CLA: item.clarity,
        CUT: item.cut ? item.cut : " ",
        POL: item.pol,
        SYM: item.sym,
        FLR: item.flo,
        MEASUREMENTS: item.measurements,
        DEP: !item.depthpercent ? "" : (Number(item.depthpercent)).toFixed(2),
        "TABLE%": !item.tablepercent ? "" : (Number(item.tablepercent)).toFixed(2),
        "CR ANG": !item.crownangle ? "" : (Number(item.crownangle)).toFixed(2),
        LAB: item.lab,
        RAP: item.rapnetprice,
        DIS: parseFloat((Number(item.discount)).toFixed(2)),
        PPC: parseFloat((Number(item.price)).toFixed(2)),
        TOTAL: parseFloat((Number(item.total)).toFixed(2)),
        LOCATION: item.location,
        STATUS: item.status,
        KEYTOSYMBOLS: item.keytosymbols ? item.keytosymbols : " ",
        MEDIA: {
          t: "s",
          v: "Media URL",
          l: {
            Target: item.stonemediaurl,
            Tooltip: "Click to open images & videos",
          }, TOTAL: (Number(item.total)).toFixed(2),
        },
        status: item.status ? item.status : "",
        holdstonecustomerid: item.holdstonecustomerid,
        holdstoneuserid: item.holdstoneuserid,
        holdstonebrokerid: item.holdstonebrokerid,
        TABLEINC: item.tableinc ? item.tableinc : "",
        SIDEINC: item.sideinc ? item.sideinc : "",
        H_AND_A: item.h_and_a ? item.h_and_a : "",
        EYECLEAN: item.eyeclean ? item.eyeclean : "",
        TINGE: item.tinge ? item.tinge : "",
        MILKY: item.milky ? item.milky : "",
        OPEN: item.open ? item.open : "",
        LUSTER: item.luster ? item.luster : "",
        TABLEBLACK: item.tableblack ? "YES" : "NO",
        SIDEBLACK: item.sideblack ? "YES" : "NO",
      };
    });

    const calculatedRow = getSummaryData();

    //addding last row for summary data
    const lastRow = Object.fromEntries(
      Constants.STOCK_EXCEL_KEYS.map(key => [key, calculatedRow[key] || ""])
    );

    //addding last row for summary data
    excelData.push(lastRow);

    const exportColumns = fullExcel
      ? [...Constants.STOCK_EXCEL_COLUMNS, ...Constants.EXCEL_OPTIONAL_COLUMNS]
      : Constants.STOCK_EXCEL_COLUMNS;

    createExcelFile(excelData, customerId, exportColumns, "PI-Stock.xlsx");
  }

  const createOffer = (data) => {
    setLoadingButton(true);
    const usertype = Constants.loggedInUser.usertype;
    StoneProxy.CreateOffer(data, usertype, (responseData) => {
      if (responseData) {
        handleSearch();
        setShowSuccessSnackbar(true);
        setSuccessMessage("Offer created successfully");
        setSnackbarVariant("success");
        setLoadingButton(false);
        setShowOfferModal(false);
      } else {
        setShowSuccessSnackbar(true);
        setSuccessMessage(Constants.APiFailErrorMessage);
        setSnackbarVariant("error");
        setLoadingButton(false);
        setShowOfferModal(false);
      }
    });
  };

  const createProforma = (data) => {
    setLoadingProformaButton(true);
    StoneProxy.CreatePerforma(data, (responseData) => {
      if (responseData && responseData.status === "Success") {
        handleSearch();
        setShowSuccessSnackbar(true);
        setSuccessMessage("Proforma created successfully");
        setSnackbarVariant("success");
        setShowSellModal(false);
        setLoadingProformaButton(false);
      } else {
        setShowSellModal(false);
        setShowSuccessSnackbar(true);
        setSuccessMessage(responseData ? responseData.errorMessage : Constants.APiFailErrorMessage);
        setSnackbarVariant("error");
        setLoadingProformaButton(false);
      }
    });
  };

  const handleStoneDetailModal = (params) => {
    setStoneId(params.value);
    setShowStoneDetailModal(true);
  };

  const checkDiffrentCustomerCompany = () => {
    setCustomerId({});
    try {
      let customerCompanyName = "";
      let flag = true;
      let customer = {};
      selectionModel.forEach(stoneid => {
        if (flag) {
          customerCompanyName = (listData.find((data) => data.stoneid === stoneid)).customercompanyname;
          flag = false;
        } else if (customerCompanyName !== (listData.find((data) => data.stoneid === stoneid)).customercompanyname) {
          setShowSnackbar(true);
          throw new Error("Different customer company name found");
        }
      });
      customer = Constants.loggedInUser.usertype === "C" ?
        { label: Constants.loggedInUser.companyname, value: Constants.loggedInUser.id } :
        customerData.customerOptions.filter(data => data.label === customerCompanyName)[0];

      setCustomerId(customer);
      return customer;
    } catch (e) { }
  }

  const loadTotalData = (data) => {
    let totalSize = 0;
    let totalPrice = 0;   //ppc*size
    let total = 0;       //rapnetprice*size

    data.forEach((iData) => {
      let pricePerCarat = iData.price
      totalSize += iData.size;
      totalPrice += (iData.size * pricePerCarat);
      total += (iData.size * ((100 * pricePerCarat) / (100 + iData.discount)));

    });
    setNoOfSelectedStones(data.length);
    setSelectedTotalSize(Utility.ConvertNumberWithSpecifiedDigits(totalSize));
    setSelectedtotalPrice(Utility.ConvertNumberWithSpecifiedDigits(totalPrice));
    setSelectedavgPrice(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          totalPrice / totalSize
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
    setSelectedAvgDiscount(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          (100 - (totalPrice / total) * 100) * -1
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
  };

  useEffect(() => {
    if (selectionModel.length <= 0) {
      loadTotalData(listData);
      return;
    }
    let totalSize = 0;
    let totalPrice = 0;   //ppc*size
    let total = 0;       //rapnetprice*size
    listData.forEach((iData) => {
      if (selectionModel.includes(iData.stoneid)) {
        let pricePerCarat = iData.price
        totalSize += iData.size;
        totalPrice += (iData.size * pricePerCarat);
        total += (iData.size * ((100 * pricePerCarat) / (100 + iData.discount)));
      }
    });
    setNoOfSelectedStones(selectionModel.length);
    setSelectedTotalSize(Utility.ConvertNumberWithSpecifiedDigits(totalSize));
    setSelectedtotalPrice(Utility.ConvertNumberWithSpecifiedDigits(totalPrice));
    setSelectedavgPrice(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(totalPrice / totalSize)
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
    setSelectedAvgDiscount(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          (100 - (totalPrice / total) * 100) * -1
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
  }, [selectionModel]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(event.target.textContent);
    setTabValue(newValue);
  };

  const columnsData = {
    "item-1": {
      field: "customercompanyname",
      headerName: "CUSTOMER COMPANY",
      headerAlign: "center",
      align: "center",
      width: 180,
      renderCell: renderCellExpand,
      // (
      // <Chip
      //   avatar={<Avatar>{params.row.customerid}</Avatar>}
      //   label={params.row.customercompanyname}
      // onClick={() => {
      //   this.setState({
      //     showAddPermissionModal: true,
      //     editOperation: false,
      //     sourceData: undefined,
      //     permissionId: item.permissionid,
      //   });
      // }}
      // sx={{ margin: "10px 10px 10px 0px" }}
      // />
      // ),
    },
    "5dd43313-18b9-41a5-9e07-09d61ad6863c": {
      field: "stoneid",
      headerName: "STONEID",
      width: 80,
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.NeedToShowStoneDetailModal() ?
        <Button
          sx={{ textDecorationLine: "underline", color: "black" }}
          onClick={() => handleStoneDetailModal(params)}
        >
          {params.value}
        </Button>
        :
        <div>{params.value}</div>,
    },
    "e24542ae-7b98-44f2-82be-09dfa2dd850b": {
      field: "mumid",
      headerName: "ID",
      headerAlign: "center",
      align: "center",
      width: 90,
      renderCell: (params) => (!params.value) ? "" : params.value,
    },
    "7a913460-41e0-441d-85b9-1f33d71416fb": {
      field: "suratid",
      headerName: "REF NO",
      headerAlign: "center",
      align: "center",
      width: 90,
      renderCell: (params) => (!params.value) ? "" : params.value,
    },
    "9dfe5dd6-726c-465b-9f61-22fca6660b4f": {
      field: "kapanid",
      headerName: "KAPANID",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => (Utility.NeedToShowKapanDetailModal()) ?
        <Button
          sx={{
            textDecorationLine: "underline",
            color: 'black',
          }}
          onClick={() => {
            setKapanId(params.row.kapanid);
            setShowKapanDetailModal(true);
          }}
        >
          {params.value}
        </Button>
        :
        <div>{params.value}</div>,
      width: 80,
    },
    "8a492e00-6167-45de-b078-e572e47c8a39": {
      field: "packetid",
      headerName: "PACKETID",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 80,
      renderCell: (params) => {
        if (params.value === null || params.row.kapanid === null) {
          return;
        } else {
          return Utility.NeedToShowPacketDetailModal() ? (
            <Button
              sx={{ textDecorationLine: "underline", color: "black" }}
              onClick={() => handlePacketDetailModal(params.value, params.row.kapanid)}
            >
              {params.value}
            </Button>
          ) : (
            <div>{params.value}</div>
          );
        }
      }
    },
    "62c37a29-d2ff-4c72-8cb3-07e52a83d484": {
      field: "status",
      headerName: "STATUS",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: renderCellExpand,
    },
    "52599510-9698-4cd3-90b7-7ac22b6af7e2": {
      field: "stonetype",
      headerName: "STONETYPE",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "singleSelect",
      valueOptions: activeTab === "Natural" ? ["Natural"] : Constants.uniqueFilterValues.stonetype.filter(option => option.name !== 'N').map(option => option.fullname),
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => Constants.STONE_TYPE[params.value],
      renderCell: (params) => Constants.STONE_TYPE[params.value],
    },
    "eb5db767-47d2-4444-9b52-7dc35c853fc7": {
      field: "shape",
      headerName: "SHAPE",
      headerAlign: "center",
      align: "center",
      width: 80,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.shape.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "9f0b7352-8ca1-459d-944c-eb46dad5aed1": {
      field: "size",
      headerName: "SIZE",
      headerAlign: "center",
      align: "right",
      width: 40,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.size)
    },
    "fe7c00f1-774a-45a2-aec0-e5fb2ea1101e": {
      field: "color",
      headerName: "COLOR",
      headerAlign: "center",
      align: "center",
      width: 65,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.color.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "d4992de9-92ab-4f9e-ba12-6c746e935611": {
      field: "colordescriptions",
      headerName: "COLOR DESCRIPTIONS",
      headerAlign: "center",
      align: "center",
      width: 160,
      renderCell: renderCellExpand,
    },
    "1035d1d0-bc7c-404f-8f58-c80bea2de613": {
      field: "clarity",
      headerName: "CLARITY",
      headerAlign: "center",
      align: "center",
      width: 75,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.clarity.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "3597803f-8932-40c6-8de6-81006f4d6d5b": {
      field: "cut",
      headerName: "CUT",
      headerAlign: "center",
      align: "center",
      width: 50,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.cut.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "859c71c9-c9c8-4f2c-9eb7-08e388e505ad": {
      field: "pol",
      headerName: "POL",
      headerAlign: "center",
      align: "center",
      width: 50,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.pol.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "5541c182-21b8-496e-b342-b0b89f3d302f": {
      field: "sym",
      headerName: "SYM",
      headerAlign: "center",
      align: "center",
      width: 40,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.sym.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "8296e627-0be5-4a66-830f-ea6867cea137": {
      field: "flo",
      headerName: "FLO",
      headerAlign: "center",
      align: "center",
      width: 60,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.flo.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "798a8663-0f0c-41be-8512-16dd60d5f25e": {
      field: "discount",
      headerName: "DIS",
      headerAlign: "center",
      align: "right",
      width: 50,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.discount)
    },
    "53c8a138-3f8e-486c-a9ba-f5c671065ad7": {
      field: "rapnetprice",
      headerName: "RAP",
      headerAlign: "center",
      align: "right",
      width: 70,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.rapnetprice)
    },
    "39c634f1-2644-4307-acbb-983b4de4229e": {
      field: "price",
      headerName: "PPC",
      headerAlign: "center",
      align: "right",
      width: 70,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.price)
    },
    "7df28e0e-0303-4ff8-a432-9dedb384afa8": {
      field: "total",
      headerName: "TOTAL",
      headerAlign: "center",
      align: "center",
      width: 70,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.total)
    },
    "13d48508-b8c9-4661-8a6c-9fb22a3408a3": {
      field: "measurements",
      headerName: "MEASUREMENTS",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 140,
      renderCell: renderCellExpand,
    },
    "567202e6-c31c-4c19-9998-1cacae05af6e": {
      field: "depth",
      headerName: "DEPTH",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: renderCellExpand,
    },
    "daffdd4f-4726-4abc-b8b0-fd4750c874be": {
      field: "lab",
      headerName: "LAB",
      headerAlign: "center",
      align: "center",
      width: 40,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.lab.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },

    "19ce7030-402c-495c-84ac-a29093bdb0ac": {
      field: "locationid",
      headerName: "LOCATION ID",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 90,
    },
    "ab3e506e-bddb-456d-b967-922dcee74d56": {
      field: "location",
      headerName: "LOCATION",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.location.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "f97a0118-3891-4f77-abf7-8636c26d594c": {
      field: "country",
      headerName: "COUNTRY",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "cb7e6add-67ba-4194-ac49-fd0d967db4e8": {
      field: "quality",
      headerName: "QUALITY",
      headerAlign: "center",
      align: "center",
      width: 80,
      renderCell: renderCellExpand,
    },
    "b718f242-4a82-42e7-b98a-40bbf0f67c21": {
      field: "shade",
      headerName: "SHADE",
      headerAlign: "center",
      align: "center",
      width: 60,
      renderCell: renderCellExpand,
    },
    "01e90aca-bdcb-4e8e-80ec-2d7007df8cd3": {
      field: "createdat",
      headerName: "CREATED AT",
      headerAlign: "center",
      align: "center",
      width: 170,
      type: "dateTime",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
    },
    "3c62ef48-9538-4df7-9484-a9ae1ba31086": {
      field: "height",
      headerName: "HEIGHT",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: renderCellExpand,
    },
    "eed9b7eb-17e4-4ec6-9c9d-c299f885544c": {
      field: "width",
      headerName: "WIDTH",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: renderCellExpand,
    },
    "8eaa8a03-d163-436d-8912-51ea06306f44": {
      field: "certificateid",
      headerName: "CERT",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: renderCellExpand,
    },
    "77e48fa7-d118-4ab8-865b-9b85b32a004f": {
      field: "fancycolor1",
      headerName: "F.COLOR",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "ccba9873-174e-4060-963a-9893c3625bb2": {
      field: "fancycolorovertone",
      headerName: "OVERTONE",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "c9aa6ee7-30e3-423e-a534-80bb5ef7bbaf": {
      field: "fancycolorintensity",
      headerName: "F.COL.INTENSITY",
      headerAlign: "center",
      align: "center",
      width: 140,
      renderCell: renderCellExpand,
    },
    "706a5cfb-e196-43d1-bbe3-c52aad9a46c1": {
      field: "comment",
      headerName: "COMMENT",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "e7210f4a-6e0a-4591-8428-e6845004ed04": {
      field: "crownheight",
      headerName: "CR.HEIGHT",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "c4e65984-1682-4c1e-812b-8938e9078b2d": {
      field: "crownangle",
      headerName: "CR.ANG",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "0f1de38d-3ae3-4209-a4d5-afe9f3018f22": {
      field: "culetsize",
      headerName: "CULET SZ",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "e3f77521-2c57-46bc-a02b-3c884685d2be": {
      field: "culetcondition",
      headerName: "CULET",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "e5c1f34e-6e1c-4ee8-bb8e-3236716fd1ff": {
      field: "depthpercent",
      headerName: "DEPTH%",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 75,
      renderCell: renderCellExpand,
    },
    "e83c2978-9088-49f0-9dc1-bcced73025fd": {
      field: "gridlemin",
      headerName: "GIRDLEMIN",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "cee57bac-9c19-40d5-b51a-51ed913dbf73": {
      field: "intensitylongtitle",
      headerName: "INTENSITYLONGTITLE",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "06d2a589-0d42-4dde-8724-acf2448c839a": {
      field: "laserinscription",
      headerName: "INS",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "dd934505-1865-48cb-878f-f5d3c18af2d5": {
      field: "note",
      headerName: "NOTE",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "61f8a5f2-8516-419a-b6fd-39ef109cc2f4": {
      field: "paviliondepth",
      headerName: "PV.DEPTH",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "70498a64-1f5f-4f03-8910-a6d7851e4aba": {
      field: "tablepercent",
      headerName: "TABLE%",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 75,
      renderCell: renderCellExpand,
    },
    "db078198-4416-4d53-b3d0-70d3a5418f65": {
      field: "open",
      headerName: "OPEN",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "e9028170-e978-4978-a2c9-1889c1821495": {
      field: "gridlecondition",
      headerName: "GIRDLE COND",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "fe8f55f3-358a-4418-bcdf-c3da4b01db67": {
      field: "gridlepercent",
      headerName: "GIRDLE%",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "daf69bba-bb1f-4d54-9dc7-9383ad429585": {
      field: "pavilionangle",
      headerName: "PV.ANGLE",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "ecfdfc0c-6a25-4a6d-9c8f-3406c23410af": {
      field: "white",
      headerName: "WHITE",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    "24ba0bf8-4ca1-4726-ad90-19a62c8c72e6": {
      field: "boxid",
      headerName: "BOXID",
      headerAlign: "center",
      width: 60,
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "cf694b75-ba5d-4a73-8fcf-e7566974c4b6": {
      field: "media",
      headerName: "MEDIA",
      headerAlign: "center",
      align: "center",
      width: 60,
      renderCell: (params) => (
        <Tooltip title={"Stone Media"} sx={{ cursor: "pointer" }}>
          <VideoLibraryTwoToneIcon
            sx={{ cursor: "pointer" }}
            onClick={() => {
              setStoneMediaURL(params.row.stonemediaurl);
              setShowStoneMediaModal(true);
            }} />
        </Tooltip>
      ),
    },
    "f3223657-c8d2-449c-b2f5-5a54c78401ce": {
      field: "tableinc",
      headerName: "TABLE INC",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
    },
    "f114ad2c-8560-4da7-9b03-03ba6bfe39a5": {
      field: "sideinc",
      headerName: "SIDE INC",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "e993a4f7-7c50-4d83-abae-fccc03382742": {
      field: "h_and_a",
      headerName: "H&A",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "f2fe7666-6489-40ce-b4b7-040c68c88bf3": {
      field: "eyeclean",
      headerName: "EYE CLEAN",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "b38b9fdf-bfb8-43c6-82a2-1e366fa71523": {
      field: "tinge",
      headerName: "TINGE",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.tinge.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 120,
    },
    "c95089ee-166d-4783-817c-2638f6d40df1": {
      field: "milky",
      headerName: "MILKY",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.milky.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 120,
    },
    "2a6475ff-481f-48c6-9e92-3ede0b97d7c0": {
      field: "luster",
      headerName: "LUSTER",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "556ae429-3605-4df4-88d8-b5223fc2e2fb": {
      field: "tableblack",
      headerName: "TABLE BLACK",
      headerAlign: "center",
      align: "center",
      type: "boolean",
      width: 120,
    },
    "5c70d1ca-2a7b-4660-8160-0beff7ad1150": {
      field: "sideblack",
      headerName: "SIDE BLACK",
      headerAlign: "center",
      align: "center",
      type: "boolean",
      width: 120,
    },
    "a1299782-d545-4d70-bcbc-7d576e396d64": {
      field: "length",
      headerName: "LENGTH",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
    },
    "dfd5488a-b600-4e75-9735-98c26f78dc84": {
      field: "strln",
      headerName: "STAR LENGTH",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "66dfbc62-477f-42f0-8097-56c5d8329156": {
      field: "lrhalf",
      headerName: "LR HALF",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
    },
    "e683145c-29dd-4d41-af1a-518ff80090d2": {
      field: "keytosymbols",
      headerName: "KEY TO SYMBOLS",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "e32fe363-07cc-4307-82d2-82ae1069b5be": {
      field: "age",
      headerName: "AGE",
      headerAlign: "center",
      align: "center",
      width: 75,
      renderCell: (params) => Utility.ConvertDateToAge(params.value),
    }
  };

  const rows = listData;
  const columns = columnNames;

  //Custom Top Menu Bar
  function CustomToolbar() {
    const [exportMenu, setExportMenu] = useState(undefined);
    const buttonMinWidth = Utility.isReadAllowed(fullExcelPermission) ? "130px" : "100px";
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          alignItems: "center",
          marginHorizontal: "5px",
          "&.MuiDataGrid-toolbarContainer": {
            padding: "0px 4px !important",
          },
        }}
      >
        <CommonStoneSelection
          title={"Enter multiple Stone Ids"}
          handleSelection={handleSelection}
          buttonDisabled={rows.length === 0}
        />
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <Box sx={{ flexGrow: 1, display: { md: "none", lg: "block" } }} />
        {/* Custom Buttons */}
        {listLoader ? (
          <CircularProgress size="1rem" />
        ) : (
          <Tooltip title="Reload List">
            <RefreshOutlinedIcon
              onClick={() => {
                getAllCustomerData();
              }}
              color="primary"
              fontSize="medium"
              sx={{ cursor: "pointer", mr: 1 }}
            />
          </Tooltip>
        )}
        <Tooltip title={"Release Stone"}>
          <Button
            variant="outlined"
            size="small"
            component="label"
            sx={{
              ml: "5px",
              "& .Mui-disabled": {
                color: "rgba (0,0,0,0.26) !important",
              },
            }}
            startIcon={<RiInboxUnarchiveLine />}
            disabled={selectionModel.length === 0 || disableAllButtons}
            onClick={() => {
              let data = [];
              selectionModel.map((iStone) => {
                let iData = listData.find((iList) => iList.stoneid === iStone);
                if (iData) {
                  data.push({ id: iData.stoneid, status: iData.status });
                }
                return true;
              });
              setReleaseData(data);
              setShowReleaseModal(true);
            }}
          >
            Release
          </Button>
        </Tooltip>
        {Utility.isReadAllowed(sellPermission) ? (
          <Tooltip title="Sell Stones">
            <Button
              variant="outlined"
              component="label"
              size="small"
              sx={{ ml: "5px" }}
              startIcon={<DiamondOutlined size="large" />}
              color="success"
              disabled={selectionModel.length === 0 || disableAllButtons}
              onClick={() => {
                let customer = checkDiffrentCustomerCompany();
                if (customer && Object.keys(customer).length > 0)
                  setShowSellModal(true);
              }}
            >
              {Utility.GetBuyOrSell()}
            </Button>
          </Tooltip>
        ) : null}
        {!isPermitted && activeTab === "Natural" ? (
          <Tooltip title="Create Memo">
            <Button
              color="primary"
              variant="outlined"
              size="small"
              component="label"
              sx={{ ml: "5px" }}
              startIcon={<AddBoxOutlinedIcon size="large" />}
              disabled={selectionModel.length === 0 || disableAllButtons}
              onClick={() => {
                let customer = checkDiffrentCustomerCompany();
                if (customer && Object.keys(customer).length > 0) setShow(true);
              }}
            >
              Memo
            </Button>
          </Tooltip>
        ) : null}
        {show ? (
          <CreateMemoModal
            show={true}
            setShow={setShow}
            handleValidation={handleValidation}
            handleSave={createMemo}
            stoneId={selectionModel}
            customer={customerId}
            loading={loadingButton}
          />
        ) : null}
        {showSellModal ? (
          <SellMemoModal
            show={true}
            setShow={setShowSellModal}
            handleValidation={handleValidation}
            handleInvoice={sellStones}
            handleProforma={createProforma}
            stoneId={selectionModel}
            customer={customerId}
            user={
              Constants.loggedInUser.id +
              " | " +
              Constants.loggedInUser.companyname
            }
            notPermitted={false}
            proformaButton={true}
            loading={loadingButton}
            loadingProformaButton={loadingProformaButton}
          />
        ) : null}
        {!isPermitted && Utility.isReadAllowed(offerPermission) ? (
          <Tooltip title="Offer">
            <Button
              variant="outlined"
              size="small"
              component="label"
              sx={{ ml: "5px" }}
              startIcon={<LocalOfferIcon size="large" />}
              color="secondary"
              disabled={selectionModel.length === 0 || disableAllButtons}
              onClick={() => {
                let customer = checkDiffrentCustomerCompany();
                if (customer && Object.keys(customer).length > 0)
                  setShowOfferModal(true);
              }}
            >
              OFFER
            </Button>
          </Tooltip>
        ) : null}
        {showOfferModal ? (
          <OfferModal
            show={true}
            setShow={setShowOfferModal}
            handleValidation={handleValidation}
            handleOffer={createOffer}
            stoneId={selectionModel}
            customer={customerId}
            user={
              Constants.loggedInUser.id +
              " | " +
              Constants.loggedInUser.companyname
            }
            loadingOfferButton={loadingButton}
            notPermitted={false}
          />
        ) : null}
        {isPermitted ||
          Constants.loggedInUser.usertype.toUpperCase() === "B" ? null : (
          <Tooltip title="Add to Watchlist">
            <LoadingButton
              color="warning"
              variant="outlined"
              size="small"
              component="label"
              sx={{ ml: "5px" }}
              disabled={selectionModel.length === 0 || disableAllButtons}
              onClick={() => {
                if (selectionModel.length > 0) {
                  let dataArray = rows.filter((iRow) =>
                    selectionModel.includes(iRow.stoneid)
                  );
                  setWatchlistData(dataArray);
                  setShowWatchlistModal(true);
                }
              }}
              loading={watchlistLoader}
              loadingPosition="start"
              startIcon={<VisibilityOutlined size="large" />}
            >
              Watchlist
            </LoadingButton>
          </Tooltip>
        )}
        {!Utility.isReadAllowed(fullExcelPermission) ? (
          <Button
            component="label"
            variant="outlined"
            size="small"
            color="secondary"
            sx={{ ml: "5px" }}
            startIcon={<Download size="large" />}
            onClick={() => {
              getExcelData(false);
            }}
          >
            EXCEL
          </Button>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              marginLeft: "5px",
              "& .MuiButton-startIcon": {
                marginRight: "0px !important",
                marginLeft: "-2px",
              },
              "& .MuiLoadingButton-loadingIndicator": { left: "7px" },
            }}
          >
            <LoadingButton
              id="demo-customized-export-menu"
              aria-controls={
                exportMenu ? "demo-customized-export-menu" : undefined
              }
              aria-haspopup="true"
              aria-expanded={exportMenu ? "true" : undefined}
              variant="outlined"
              disableElevation
              disabled={rows.length === 0}
              onClick={(e) => setExportMenu(e.currentTarget)}
              sx={{
                color: "#2e7d32",
                borderRadius: "4px",
                border: "1px solid rgba(46, 125, 50, 0.5)",
                padding: "2px 2px 2px 8px",
                cursor: "pointer",
              }}
              loadingPosition="start"
              startIcon={<TbTableExport size={18} />}
            >
              <span style={{ fontSize: "14px", marginLeft: "4px" }}>EXPORT</span>
              <KeyboardArrowDownIcon />
            </LoadingButton>

            <StyledMenuButtons
              id="demo-customized-export-menu"
              MenuListProps={{
                "aria-labelledby": "demo-customized-export-menu",
                style: {
                  maxHeight: 250,
                },
              }}
              anchorEl={exportMenu}
              open={exportMenu}
              onClose={() => setExportMenu(null)}
            >
              <MenuItem>
                {Utility.isReadAllowed(fullExcelPermission) &&
                  <Button
                    component="label"
                    variant="outlined"
                    size="small"
                    color="secondary"
                    sx={{
                      ml: "5px",
                      minWidth: buttonMinWidth,
                      justifyContent: "flex-start",
                      textAlign: "left",
                      "& .MuiButton-startIcon": {
                        marginRight: "1px",
                        marginLeft: "0px",
                      },
                    }}
                    startIcon={<Download />}
                    onClick={() => {
                      getExcelData(true);
                      setExportMenu(null);
                    }}
                  >
                    FULL EXCEL
                  </Button>
                }
              </MenuItem>
              <MenuItem>
                <Button
                  component="label"
                  variant="outlined"
                  size="small"
                  color="secondary"
                  sx={{
                    ml: "5px",
                    minWidth: buttonMinWidth,
                    justifyContent: "flex-start",
                    textAlign: "left",
                    "& .MuiButton-startIcon": {
                      marginRight: "1px",
                      marginLeft: "0px",
                    },
                  }}
                  startIcon={<Download />}
                  onClick={() => {
                    getExcelData(false);
                    setExportMenu(null);
                  }}
                >
                  EXCEL
                </Button>
              </MenuItem>
            </StyledMenuButtons>
          </Box>
        )}
        <GridToolbarQuickFilter />
      </GridToolbarContainer>
    );
  }

  return (
    <div>
      {/* Modals  */}
      <div>
        <TabMenuSnackbar
          show={errorSnackbar}
          message={errorMessage}
          variant={"error"}
          autoHide={Constants.SnackBarCloseTimer}
          title={"Failed"}
          handleClose={() => setErrorSnackbar(false)}
        />
        {showSuccessSnackbar ? (
          <TabMenuSnackbar
            show={true}
            message={successMessage}
            variant={snackbarVariant}
            autoHide={Constants.SnackBarCloseTimer}
            title={snackbarVariant === "success" ? "Success" : "Failed"}
            handleClose={handleClose}
          />
        ) : null}
        {showSnackbar ? (
          <TabMenuSnackbar
            show={showSnackbar}
            message={
              "To perform this action, Please select stones belongs to same customer company"
            }
            variant={"warning"}
            autoHide={false}
            title={"Warning"}
            handleClose={() => {
              setShowSnackbar(false);
            }}
          />
        ) : null}
        {warningStatus.length !== 0 ? (
          <CommonSnackbar
            show={true}
            message={
              'Please select stones with status "AVAILABLE" or "MEMO_REQUESTED"'
            }
            variant={"warning"}
            autoHide={Constants.SnackBarCloseTimer}
            title={"Warning"}
            handleClose={() => {
              setWarningStatus([]);
            }}
          />
        ) : null}

        {showStoneDetailModal ? (
          <StoneDetailModal
            show={showStoneDetailModal}
            stoneId={stoneId}
            handleClose={handleClose}
          />
        ) : null}
        {showKapanDetailModal ? (
          <KapanHistoryModal
            show={showKapanDetailModal}
            kapanId={kapanId}
            close={() => setShowKapanDetailModal(false)}
          />
        ) : null}

        {showStoneMediaModal ? (
          <>
            <StoneMediaModal
              show={showStoneMediaModal}
              stoneMediaURL={stoneMediaURL}
              handleClose={() => setShowStoneMediaModal(false)}
            />
          </>
        ) : null}

        {showPacketDetailModal ? (
          <PacketHistoryModal
            show={showPacketDetailModal}
            packetId={packetId}
            kapanId={kapanId}
            close={handleClose}
          />
        ) : null}

        {showReleaseModal && (
          <ReleaseStoneModal
            show={true}
            setShow={setShowReleaseModal}
            handleValidation={handleValidation}
            handleSave={releaseStone}
            stoneId={selectionModel}
            customer={listData[0].customerid}
            loading={loadingButton}
            data={releaseData}
          />
        )}

        {showUserDetailModal ? (
          <UserDetailModal
            show={true}
            handleClose={() => setShowUserDetailModal(false)}
            handleSelect={(selectedOption) => {
              const selectedCustomers = customerData.customerOptions.filter(
                (opt) => selectedOption.includes(opt.value)
              );
              setCustomerData({
                ...customerData,
                customer: selectedCustomers,
              });
              setShowUserDetailModal(false);
            }}
            userids={customerData.customerOptions
              .filter((option) => option.value !== "*")
              .map((cust) => cust.value)}
            selectedIds={
              customerData.customer.length !== 0
                ? customerData.customer.map((iCustomer) => iCustomer.value)
                : []
            }
            usertype={"U"}
            loading={showUserDetailModal}
            isMulti={true}
          />
        ) : null}

        {showWatchlistModal ? (
          <WatchlistModal
            stoneData={watchlistData}
            handleSave={addToWatchlist}
            watchlistLoader={watchlistLoader}
            handleClose={() => setShowWatchlistModal(false)}
          />
        ) : null}
      </div>
      <div>
        <Box
          sx={{
            display: "flex",

            "& .MuiTabs-flexContainer": {
              marginLeft: "15px",
              marginTop: "0px",
            },
          }}
        >
          {showNaturalTab && showLabGrownTab && (
            <Tabs value={tabValue} onChange={handleTabChange} sx={{
              "& .MuiTabs-indicator": {
                height: "3px",
                bottom: "5px"
              },
              "& .MuiTabs-flexContainer": {
                marginLeft: "15px",
                marginTop: "3px"
              }
            }}>
              <Tab label="Natural" />
              <Tab label="Lab Grown" />
            </Tabs>
          )}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexGrow: 1,
              flexBasis: 0,
              overflow: "hidden",
              color: "black",
              fontWeight: "normal",
              px: 1,
              textAlign: "center",
              paddingTop: "5px"
            }}
          >
            <Stack
              direction="row"
              spacing={2}
              useFlexGap
              flexWrap="wrap"
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                justifyContent: "center",
              }}
            >
              <Typography
                component="span"
                sx={{ fontSize: Constants.defaultTableFontSize }}
              >
                No of Stones: <b>{noOfSelectedStones}</b>
              </Typography>
              <Typography
                component="span"
                sx={{ fontSize: Constants.defaultTableFontSize }}
              >
                Total Weight: <b>{selectedTotalSize}</b>
              </Typography>
              <Typography
                component="span"
                sx={{ fontSize: Constants.defaultTableFontSize }}
              >
                Total Price: <b>{selectedtotalPrice}</b>
              </Typography>
              <Typography
                component="span"
                sx={{ fontSize: Constants.defaultTableFontSize }}
              >
                Avg Price: <b>{selectedavgPrice}</b>
              </Typography>
              <Typography
                component="span"
                sx={{ fontSize: Constants.defaultTableFontSize }}
              >
                Avg Discount: <b>{selectedAvgDiscount}</b>
              </Typography>
            </Stack>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            margin:
              showNaturalTab && showLabGrownTab ? "8px 16px 16px" : "8px 16px",
          }}
        >
          {Constants.loggedInUser.usertype !== "C" && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <Typography>Company Name</Typography>
              <Box
                sx={{
                  gap: "5px",
                  display: "flex",
                  alignItems: "center",
                  maxWidth: "400px",
                }}
              >
                <Select
                  menuPlacement="auto"
                  blurInputOnSelect={false}
                  isMulti
                  className="basic-single"
                  classNamePrefix="select"
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  value={customerData.customer}
                  isSearchable={true}
                  name="Customer"
                  menuPortalTarget={document.body}
                  styles={{
                    ...Constants.Styles,
                    container: (base) => ({
                      ...base,
                      minWidth: "10vw",
                    }),
                  }}
                  options={customerData.customerOptions}
                  onChange={(selectedOption) => {
                    setCustomerData({
                      ...customerData,
                      customer: selectedOption,
                    });
                  }}
                />
                <Tooltip title="View More Data">
                  <OpenInNewIcon
                    style={{ cursor: "pointer" }}
                    fontSize="medium"
                    color="action"
                    onClick={() => setShowUserDetailModal(true)}
                  />
                </Tooltip>
              </Box>
              <LoadingButton
                variant="contained"
                onClick={() => handleSearch()}
                startIcon={<SearchOutlined size="large" />}
                loading={listLoader}
                loadingPosition="start"
                disabled={customerData.customer.length === 0}
              >
                Search
              </LoadingButton>
            </Box>
          )}
        </Box>

        {/* Data Grid */}
        <Box
          sx={{
            px: 1,
            width: "100%",
            position: "relative",
            backgroundColor: "#fff",
            color: "#000",
            "& .MuiTablePagination-selectLabel": {
              marginTop: "15px",
            },
            "& .MuiTablePagination-displayedRows": {
              marginTop: "15px",
            },
            "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
              fontWeight: Constants.defaultFontWeight,
            },
            "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
              color: "#1976d2",
              padding: "4px 5px",
              borderRadius: "4px",
            },
            "& .css-znmrd6-MuiButtonBase-root-MuiButton-root": {
              color: "#1976d2",
              padding: "5px 5px",
              borderRadius: "4px",
            },
            "& .css-cc8tf1": {
              fontWeight: Constants.defaultFontWeight,
            },
            height: showNaturalTab && showLabGrownTab ? "73vh" : "80vh",
          }}
        >
          <DataGridPro
            sx={{
              "& .MuiDataGrid-columnHeader": {
                color: "#fff",
                backgroundColor: "grey",
              },
              "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                py: "6px",
              },
              "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                py: "12px",
              },
              "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                py: "18px",
              },

              fontSize: Constants.defaultTableFontSize,
              fontWeight: Constants.defaultFontWeight,
            }}
            density="compact"
            disableRowSelectionOnClick={true}
            slots={{ toolbar: CustomToolbar }}
            rows={rows}
            columns={columns}
            getRowId={(row) => row.stoneid}
            checkboxSelection={true}
            onRowSelectionModelChange={(newSelectionModel) => {
              setSelectionModel(newSelectionModel);

              let customers = {};
              listData.map((iStone) => {
                if (newSelectionModel.includes(iStone.stoneid))
                  customers[iStone.customerid] = 0;

                return true;
              });
            }}
            loading={listLoader}
            rowSelectionModel={selectionModel}
            initialState={{
              columns: {
                columnVisibilityModel: {
                  // Hide columns id, the other columns will remain visible
                  locationid: false,
                  kapanid: false,
                  country: false,
                  quality: false,
                  shade: false,
                  repacode: false,
                  createdat: false,
                  height: false,
                  width: false,
                  packetid: false,
                  crownheight: false,
                  culetsize: false,
                  culetcondition: false,
                  gridlemin: false,
                  intensitylongtitle: false,
                  laserinscription: false,
                  note: false,
                  paviliondepth: false,
                  gridlecondition: false,
                  gridlepercent: false,
                  pavilionangle: false,
                  white: false,
                },
              },
              pagination: {
                paginationModel: Constants.pageSize,
              },
            }}
            pageSizeOptions={Constants.pageSizeOptions}
            pagination
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: {
                  debounceMs: 500,
                },
              },
            }}
          />
        </Box>
      </div>
    </div>
  );
};

export default HoldStoneMaster;
